import React, { useEffect, useRef } from "react";
import "./testimonials.css";
import { FaGavel, FaQuoteLeft, FaQuoteRight, FaStar } from "react-icons/fa";


const testimonials = [
  {
    id: 1,
    name: "Rainbow Education",
    comment: "Provide excellent services in law, expertise in commercial disputes & property matters.",
    rating: 5,
  },
  {
    id: 2,
    name: "Aditi Saxena",
    comment: "A genuine, wise, and affordable law adviser with a humane approach and unwavering dedication to justice.",
    rating: 5,
  },
  {
    id: 3,
    name: "Thulsidas Nair",
    comment: "Highly knowledgeable, transparent, and committed especially in property and real estate legal matters.",
    rating: 5,
  },
];

const Testimonials = () => {
  const testimonialRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("custom-testimonial-show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    testimonialRefs.current.forEach((testimonial) => {
      if (testimonial) observer.observe(testimonial);
    });

    return () => {
      testimonialRefs.current.forEach((testimonial) => {
        if (testimonial) observer.unobserve(testimonial);
      });
    };
  }, []);

  return (
    <section className="custom-testimonials-section">
      <div className="custom-testimonials-container">
        <h2 className="custom-testimonials-title">What Our <span>Clients Say</span>?</h2>

        <div className="custom-testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="custom-testimonial-card custom-testimonial-fade-in"
              ref={(el) => (testimonialRefs.current[index] = el)}
              style={{ transitionDelay: `${index * 0.2}s` }}
            >
              <FaQuoteLeft className="custom-testimonial-quote-icon custom-testimonial-quote-icon-left" />
              <p className="custom-testimonial-comment">{testimonial.comment}</p>
              <FaQuoteRight className="custom-testimonial-quote-icon custom-testimonial-quote-icon-right" />
              <div className="custom-testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} className="custom-testimonial-star-icon" />
                ))}
              </div>
              <h3 className="custom-testimonial-name">{testimonial.name}</h3>
            </div>
          ))}
        </div>

        <div className="custom-testimonials-trust-section">
          <p>Genuine <span>1000+</span> people trusting InduRatna Law Associates.</p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
